import InfiniteScroll from "react-infinite-scroll-component";
import { IPageInfiniteScrollProps } from "./pageInfiniteScroll.props";
import { LoadingIcon } from "../../assets/svg/loadingIcon";

const PageInfiniteScroll = <T,>(
  {
    renderItem,
    onItemClick,
    onItemSelect,
    hasMore,
    items,
    loadMore,
    ...props
  }: IPageInfiniteScrollProps<T>
) => {
  return <div>
    <InfiniteScroll
      dataLength={items.length}
      next={loadMore}
      hasMore={hasMore}
      loader={<div className="flex flex-row px-[20px] py-[5px] justify-center border-t-2">
        <LoadingIcon
          width={60}
          height={60}
        />
      </div>}
      scrollableTarget="scrollableDiv"
      scrollThreshold={0.9}
    >
      {items.map((item, index) => (renderItem(item, index, () => onItemClick?.(item), (checked) => onItemSelect?.(checked, item))))}
    </InfiniteScroll>
  </div>
}
export default PageInfiniteScroll;